<template>
  <div>
  <L1Vue class="TeamInformation">
    <template slot="slot_title">
      <select v-model="status">
        <option :value="null">所有狀態</option>
        <option v-for="(stat, i) in statusmap" :key="`stat-${i}`" :value="stat">{{stat}}</option>
      </select>
      <DatesSelect  :defaultValue="range" @input="range=$event"/>
      <!-- <span>
      <input type="radio" v-model="daterange" value="今日預約" before="今日" after="預約">
      <input type="radio" v-model="daterange" value="明日預約" before="明日" after="預約">
      <input type="radio" v-model="daterange" value="全部預約" before="全部" after="預約">
      <input type="radio" v-model="daterange" value="自訂時間" before="自訂" after="時間" @click="rangeSelect=true">
      </span> -->
      <input type="text" class="search" v-model="searchText" placeholder="搜尋">
      <select v-model="salesman" class="salesman">
        <option :value="null">所有業務</option>
        <option v-for="(sman, i) in salesmans" :key="`sman-${i}`" :value="sman._id">
          {{sman.department}} | {{sman.post}} | {{sman.name}}</option>
      </select>
      <button :style="{marginLeft: 'auto'}" class="addTeam" @click="addTeam=!addTeam;itemSelect=null"></button>
      <button class="printTablefn" @click="listP=!listP">功能<span v-if="listP" :style="{paddingTop: '5px', lineHeight: '10px', marginLeft: 'auto'}">🞁</span><span v-else :style="{paddingBottom: '5px', lineHeight: '10px', marginLeft: 'auto'}">🞃</span></button>
      <div v-if="listP" class="listP">
        <button class="printTable" :style="{borderRadius: 0}" @click="printTable=true;listP=false">列印團體表</button>
        <button class="printTable excel" :style="{borderRadius: 0}" @click="exportTable();listP=false">匯出Excel</button>
      </div>
    </template>
    <Table :rows="teams">
      <template slot="slot_head">
        <th :style="{width: '140px', textAlign: 'start'}">狀態</th>
        <th :style="{width: '140px', textAlign: 'start'}">參觀日期</th>
        <th :style="{width: '100px', textAlign: 'start'}">時段</th>
        <th :style="{width: '170px', textAlign: 'start'}">預約人</th>
        <th :style="{width: '50px', textAlign: 'start'}"></th>
        <th :style="{width: '200px', textAlign: 'start'}">代理商</th>
        <th :style="{width: '200px', textAlign: 'start'}">領隊</th>
        <th :style="{width: '110px', textAlign: 'center'}">預約人數</th>
        <th :style="{width: '90px', textAlign: 'center'}">導覽員</th>
        <th :style="{width: 'inherit', textAlign: 'start'}">匯款資訊/備註</th>
        <th :style="{width: '80px', textAlign: 'center'}">詳情</th>

        <!-- <th v-for="(field, i) in fields" :key="`field-${i}`" :style="[{textAlign: aligns[i], width: `${widths[i]===0? 'inherit' : `${widths[i]}px`}`}, i===10?{display: 'none'}:{}]"> -->
        <!-- <span v-if="field==='導覽需求(人)'">導覽員</span>
        <span v-else>{{field}}</span></th> -->
        </template>
        <tr :class="itemSelect&&itemSelect['_id']===_id?'selected':''" slot-scope="{item:{_id,status,visitDate,visitTime,orderer, ordererTel,agency,leader,leaderTel,reserveNum,docentCount,guideNeeds,groupName,remit5code,remitAmount,remitName,remitTime,remark},index:it}"
        @click.stop="trclicked(teams[it])">
          <!-- <td @click="uploaddata(item)">upload</td> -->
          <td :style="{textAlign: aligns[0], width: `${widths[0]}px`}">
            <div @mouseenter="extendthis" @mouseleave="closethis" class="status" :style="{backgroundColor: `var(--${status})`}">{{status}}<div class="statusBtns">
              <template v-for="sta in statusmap">
              <button :key="`sta-${sta}-${it}`" @click="updateStatus(it, _id, sta)" v-if="sta!==status&&sta!=='已付訂'&&sta!=='通知付訂'" :style="{backgroundColor: `var(--${sta})`}">{{sta}}</button>
              </template>
              <button :style="{width: 'fit-content', minWidth: '130px', paddingInline:'10px', whiteSpace:'nowrap', backgroundColor: '#C78550'}"
              @click.stop="store=rest;addTeam1=teams[it];itemSelect=null" v-for="rest in restaurantsReverse" :key="`rest-${it}-${rest}`">新增{{rest}}預約</button>
            </div></div>
          </td>
          <td :style="{textAlign: aligns[1], width: `${widths[1]}px`, whiteSpace:'nowrap'}">{{toDate(visitDate)}}</td>
          <td :style="{textAlign: aligns[2], width: `${widths[2]}px`}">{{visitTime}}</td>
          <td :style="{textAlign: aligns[3], width: `${widths[3]}px`}">{{orderer}}<br>{{ordererTel}}</td>
          <td :style="{textAlign: aligns[4], width: `${widths[4]}px`}"><div :class="agency&&agency.contract ?'contract':''">
            <svg v-if="agency&&agency.contract" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.66297 9.44074C7.98519 9.9 7.16668 10.4981 6.12964 11.1574V18.5185C6.12964 18.7574 5.17223 19.2963 4.35371 19.2963H3.93519V12.5333C3.49631 12.813 3.01668 13.0926 2.49816 13.3907C2.4389 13.65 2.2389 13.8296 2.01853 13.9093L0.542603 11.3944C1.26112 11.2352 2.47779 10.9352 3.93519 10.537V6.30926H2.69816C2.25927 7.90556 1.64075 9.38148 0.862973 10.5L0.562973 10.3611C1.02223 8.2463 1.28149 5.29259 1.32038 2.67963L3.93334 3.07778V0.683334L6.86668 0.983334C6.80742 1.26296 6.66668 1.46296 6.12779 1.54259V5.65185L7.06482 4.11482C7.06482 4.11482 8.22223 5.25185 8.84075 5.99074C8.80001 6.21111 8.60186 6.30926 8.32223 6.30926H6.12964V9.92037C6.94816 9.70185 7.76482 9.48148 8.60371 9.22222L8.66297 9.44074ZM3.93519 5.75V3.31667C3.81482 3.47593 3.6352 3.57593 3.31668 3.61667C3.19631 4.33519 3.03705 5.0537 2.85742 5.75185H3.93519V5.75ZM17.4019 9.54074C17.4019 9.54074 18.6796 10.5778 19.4574 11.2963C19.3982 11.5167 19.1982 11.6148 18.9185 11.6148H15.8259V16.763C15.8259 18.3185 15.4278 19.1574 12.6537 19.3963C12.5741 18.7185 12.4537 18.2389 12.0556 17.9C11.6556 17.5815 11.137 17.3407 9.94075 17.1611V16.9019C9.94075 16.9019 12.5945 17.0611 13.0741 17.0611C13.4333 17.0611 13.5333 16.9407 13.5333 16.6611V11.6167H7.34816L7.1889 11.0574H13.5333V8.68333L16.5259 8.94259C16.4667 9.24259 16.287 9.40185 15.8278 9.46111V11.0574H16.2463L17.4019 9.54074ZM7.60557 4.1537H11.6963V0.601852L14.6093 0.861112C14.5889 1.12037 14.4296 1.3 13.9704 1.37963V4.1537H15.7259L16.9222 2.59815C16.9222 2.59815 18.2982 3.65556 19.137 4.41296C19.0778 4.63148 18.8778 4.73148 18.5778 4.73148H13.9685V7.78333H15.3445L16.5019 6.28704C16.5019 6.28704 17.8389 7.30556 18.637 8.04259C18.5963 8.26111 18.3778 8.36111 18.0778 8.36111H8.46297L8.30371 7.78333H11.6963V4.73333H7.78519L7.60557 4.1537ZM8.56297 12.0148C14.0704 13.2519 12.3333 17.2019 10.2796 15.7463C10 14.5296 9.12223 13.0926 8.38334 12.1352L8.56297 12.0148Z" fill="white"/>
            </svg>
            </div>
          </td>
          <td :style="{textAlign: aligns[5], width: `${widths[5]}px`}">{{agency&&agency.name?agency.name:'-'}}<br><span :style="{color: 'var(--color-checked)'}">{{groupName}}</span></td>
          <td :style="{textAlign: aligns[6], width: `${widths[6]}px`}">{{leader?leader:'-'}}<br>{{leaderTel?leaderTel:'-'}}</td>
          <td :style="{textAlign: aligns[7], width: `${widths[7]}px`}">{{reserveNum}}</td>
          <td :style="{textAlign: aligns[8], width: `${widths[8]}px`}">{{guideNeeds?docentCount:guideNeeds===null?'?':'-'}}</td>
          <td :style="{textAlign: aligns[9], width: 'inherit'}"
          >
          <div>{{[remitTime&&moment(remitTime).format('gg/MM/DD HH:mm'), remit5code, remitAmount&&`${remitAmount}元`, remitName].filter(e => e).join(' ')}}</div>
          <div v-if="remark" class="toolong" :style="{maxWidth:'450px'}">{{remark}}</div>
          </td>
          <td :style="{textAlign: aligns[10], width: `${widths[10]}px`, display:'none'}">{{salesman}}</td>
          <td :style="{textAlign: aligns[11], width: `${widths[11]}px`}" class="remarkTip">
            <svg v-if="remark" width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_247_1545)">
              <mask id="mask0_247_1545" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="30">
              <path d="M25.7021 0H0.00500488V30H25.7021V0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_247_1545)">
              <path d="M16.0581 21.3674H6.42925C5.83748 21.3674 5.35938 21.8455 5.35938 22.4373C5.35938 23.0291 5.83748 23.5072 6.42925 23.5072H16.0581C16.6499 23.5072 17.128 23.0291 17.128 22.4373C17.128 21.8455 16.6499 21.3674 16.0581 21.3674ZM6.42925 14.9482C5.83748 14.9482 5.35938 15.4263 5.35938 16.0181C5.35938 16.6098 5.83748 17.0879 6.42925 17.0879H19.2678C19.8595 17.0879 20.3376 16.6098 20.3376 16.0181C20.3376 15.4263 19.8595 14.9482 19.2678 14.9482H6.42925ZM6.42925 8.52893C5.83748 8.52893 5.35938 9.00703 5.35938 9.59881C5.35938 10.1906 5.83748 10.6687 6.42925 10.6687H19.2678C19.8595 10.6687 20.3376 10.1906 20.3376 9.59881C20.3376 9.00703 19.8595 8.52893 19.2678 8.52893H6.42925Z" fill="#E37878"/>
              </g>
              <mask id="mask1_247_1545" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="30">
              <path d="M25.7021 0H0.00500488V30H25.7021V0Z" fill="white"/>
              </mask>
              <g mask="url(#mask1_247_1545)">
              <path d="M23.5373 26.7503C23.5373 27.342 23.0592 27.8201 22.4674 27.8201H3.20963C2.61785 27.8201 2.13975 27.342 2.13975 26.7503V4.28287C2.13975 3.6911 2.61785 3.21299 3.20963 3.21299H6.41926V1.07324H3.20963C1.43765 1.07324 0 2.51089 0 4.28287V26.7503C0 28.5223 1.43765 29.9599 3.20963 29.9599H22.4674C24.2394 29.9599 25.677 28.5223 25.677 26.7503V4.28287C25.677 2.51089 24.2394 1.07324 22.4674 1.07324H19.2578V3.21299H22.4674C23.0592 3.21299 23.5373 3.6911 23.5373 4.28287V26.7503Z" fill="#E37878"/>
              </g>
              <path d="M18.1812 0.0032959H7.48578V4.2828H18.1812V0.0032959Z" fill="#E37878"/>
              </g>
              <defs>
              <clipPath id="clip0_247_1545">
              <rect width="25.7021" height="30" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <div>備註: <br>{{remark}}</div>
          </td>
        </tr>
    </Table>
  </L1Vue>
    <infoSlider :show="addTeam" @close="addTeam=false" label="新增團體" :width="481" :icon="'team'">
      <new-team :sources="sources" :teamAttributes="teamAttributes" @new="getnewteam" v-if="addTeam" :addTeam="addTeam" @close="addTeam=false" :show="addTeam"/>
    </infoSlider>
    <infoSlider :printBtn="true" :show="!!itemSelect" @close="itemSelect=false" label="團體資訊" :width="481" @printInfo="print('printTeamSingle')" :icon="'team'">
      <team-info :sources="sources" :teamAttributes="teamAttributes" @updateItem="updateItem" :itemSelect="itemSelect" @close="itemSelect=null"/>
    </infoSlider>
    <newRestComp :refdata="addTeam1" :label="`新增${store}預約`" :salesmans="salesmans" :add="!!addTeam1&&store" :field2="restaurantInfo?.field2" :field3="restaurantInfo?.field3" :store="store" :storeType="restaurantInfo?.storeType"
     :types="store ? $store.getters.getTypeList(store) : []" :statuslist="store ? $store.getters.getStatusList(store) : []"
    :source="sourcesRest" :projects="restProjects" :products="products"
    @addOrder="selectProd=true" @close="addTeam1=false" @new="getnew"/>
    <restProducts v-if="selectProd" @close="selectProd=false" :style="{right: '481px'}" :products="products"/>
    <printTeamTable v-if="printTable" :teams="teams" :range="range" @close="printTable=false" v-show="printTable"/>
  </div>

</template>

<script>
import XLSX from 'xlsx'
import stringifyCss from './print.js'
import Table from '../../components/tables/t2.vue'
import L1Vue from '../../components/layout/L1.vue'
import restProducts from '../restaurantView/AddOrders.vue'
import newRestComp from '../restaurantView/addnew.vue'
import DatesSelect from '../../components/dateRadio/DatesSelect.vue'
import printTeamTable from './printTeamTable.vue'
import infoSlider from '../../components/infoSlider_v2.vue'
import NewTeam from './NewTeam.vue'
import TeamInfo from './TeamInfo.vue'
import { getapi, postapi } from '../../store/fetch'
import { mapState } from 'vuex'
const namemap = {
  參觀日期: '參訪日期',
  時段: '參訪時段',
  參觀時段: '參訪時段',
  狀態: '狀態',
  預約人: '姓名',
  代理商: '姓名',
  統一編號: '團體統編',
  團體名稱: '團體名稱',
  預約人數: '參觀人數',
  領隊: '團體名稱',
  導覽需求: '姓名',
  匯款資訊: '刷卡金額',
  業務: '姓名',
  id: '參訪單號',
  團體ID: '參訪單號',
  總金額: '總金額',
  待收金額: '待收金額',
  操作人員: '參訪單號',
  預約時間: '預約時間',
  備註: '姓名',
  一般: '一般方案',
  優待: '優待方案',
  優惠: '優惠方案'
}
const statusmap2 = {
  預約中: '預約中(未匯款)',
  通知付訂: '通知付訂',
  已付訂: '已付訂',
  已報到: '已報到',
  已取消: '已取消'
}
export default {
  name: 'TeamInformation',
  components: {
    Table,
    DatesSelect,
    L1Vue,
    restProducts,
    newRestComp,
    TeamInfo,
    NewTeam,
    infoSlider,
    printTeamTable
  },
  async mounted () {
    this.sources = await getapi('selections/sourceTeam')
    this.sourcesRest = await getapi('selections/source')
    const teamAttributes = await getapi('selections/teamAttributes')
    this.guideTopic = await getapi('selections/guideTopic')
    this.teamAttributes = teamAttributes
    if (this.$route.query?.date) {
      const d = this.moment(this.$route.query?.date).format('YYYY-MM-DD')
      this.range = { start: d, end: d }
    }
    this.getStatus()
    this.getTeams()
    this.getSalesman()
  },
  watch: {
    store () {
      this.getproducts()
    },
    range: {
      deep: true,
      handler () {
        this.getTeams()
      }
    },
    status () { this.getTeams() },
    salesman () { this.getTeams() },
    searchText () { this.getTeams() }
  },
  computed: {
    dtrg () {
      if (this.range.duration) {
        return `${this.moment(this.range.start).format('YYYY-MM-DD')} ~ ${this.moment(this.range.end).format('YYYY-MM-DD')} 團體預約參觀`
      } else if (this.range.duration === 0) {
        return `${this.moment(this.range.start).format('YYYY-MM-DD')} 團體預約參觀`
      } else {
        return this.moment(this.range.start).format('YYYY-MM-DD') + ' ~ 團體預約參觀'
      }
    },
    restaurantInfo () {
      return this.restaurantsInfos.find(e => e.name === this.store)
    },
    restProjects () {
      return this.store ? this.$store.getters.getProjectList(this.store) : []
    },
    restaurantsReverse () {
      const x = JSON.parse(JSON.stringify(this.restaurants))
      x.reverse()
      return x
    },
    ...mapState({
      restaurants: 'restaurants',
      restaurantsInfos: 'restaurantsInfos'
    })
  },
  methods: {
    print (page) {
      setTimeout(() => {
        const css = stringifyCss[page]
        const selector = '#preview.' + page
        console.log(document.getElementById('brand'), document.getElementById('brand').style.backgroundImage)
        const elem = document.getElementById('brand')
        if (elem) {
          elem.src = window.location.origin + window.location.pathname + '/brand.svg'
        }
        const content = document.querySelector(selector)
        const ht = document.createElement('html')
        const head = document.createElement('head')
        const body = document.createElement('body')
        const title = document.createElement('title')
        title.innerText = '團體預約參觀表'
        const div = document.createElement('div')
        div.id = 'preview'
        div.style.width = '200mm'
        div.style.marginInline = 'auto'
        div.innerHTML = content.innerHTML
        body.appendChild(div)
        head.appendChild(title)
        const style = document.createElement('style')
        style.media = 'print'
        style.appendChild(document.createTextNode(css))
        const style1 = document.createElement('style')
        style1.media = 'screen'
        style1.appendChild(document.createTextNode(css + 'body{margin:auto;width:210mm;background: #999999;}'))
        head.appendChild(style)
        head.appendChild(style1)
        ht.appendChild(head)
        ht.appendChild(body)
        const printWin = window.open('', '', '')
        printWin.document.write(`<html>${ht.innerHTML}</html>`)
        printWin.document.close()
        setTimeout(() => {
          printWin.print()
          this.printshow = false
        }, 500)
        return false
      }, 300)
    },
    async getproducts () {
      const products = await getapi(`rest_product/category/${this.store}?pos=true`)
      this.products = products
    },
    async updateStatus (index, _id, status) {
      const r = await postapi(`visitbooking/v2/${_id}`, { status: status })
      if (r) {
        this.teams[index].status = r.status
      }
    },
    extendthis (ev) {
      const current = ev.target
      console.log([current.className, ev.target.className])
      if (current.className === 'status') {
        if (current.lastChild.style.display) {
          current.lastChild.style.display = null
        } else {
          current.lastChild.style.display = 'flex'
        }
      }
    },
    closethis (ev) {
      const current = ev.target
      current.lastChild.style.display = null
    },
    getnew (bookrest) {
      this.$router.push({ name: 'restaurantView', query: { date: this.toDate(bookrest.visitDate) } })
    },
    async exportTable () {
      const json = JSON.parse(JSON.stringify(this.teams)).map(e => {
        return {
          狀態: e.status,
          參訪日期: this.toDate(e.visitDate),
          參訪時間: e.visitTime,
          地區: e.area,
          預約人: e.orderer,
          預約電話: e.ordererTel,
          特約: e.agency && e.agency.contract ? '特' : '-',
          代理商: e.agency && e.agency.name,
          代理商統編: e.agencyID,
          團體名稱: e.groupName,
          領隊: e.leader,
          領隊電話: e.leaderTel,
          預約人數: e.reserveNum,
          一般: e.ticketCategory && e.ticketCategory.ticket_1,
          優待: e.ticketCategory && e.ticketCategory.ticket_2,
          優惠: e.ticketCategory && e.ticketCategory.ticket_3,
          業務經辦: (e.salesman && e.salesman.name) || '-',
          業務來源: (e.salesman && e.salesman.name) || '-',
          導覽: e.guideNeeds ? 'Y' : e.guideNeeds === null ? '?' : '-',
          導覽主題: e.guideRemark || '-',
          導覽員: (e.guideNeeds && e.docentCount) || '-',
          應付: e.totalAmount || '-',
          匯款時間: e.remitTime ? this.toDateTime(e.remitTime) : '-',
          匯款5碼: e.remit5code || '-',
          戶名: e.remitName || '-',
          匯款金額: e.remitAmount || '-',
          備註: e.remark || '-'
        }
      })
      const worksheet = XLSX.utils.json_to_sheet(json)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet_1')
      XLSX.writeFile(workbook, `${this.dtrg}.xlsx`)
    },
    getnewteam (r) {
      if (this.moment(r.visitDate).isBetween(this.moment(this.range.start), this.moment(this.range.end))) {
      } else {
        this.range.start = this.moment(r.visitDate).format('YYYY-MM-DD')
        this.range.end = this.moment(r.visitDate).format('YYYY-MM-DD')
      }
      this.getTeams()
      this.addTeam = false
    },
    updateItem (data) {
      // console.log('updateItem')
      const index = this.teams.map(e => e._id).indexOf(data._id)
      this.teams.splice(index, 1, data)
      this.itemSelect = data
    },
    trclicked (item) {
      if (this.itemSelect && this.itemSelect._id === item._id) {
        this.itemSelect = null
      } else {
        this.itemSelect = JSON.parse(JSON.stringify(item))
      }
    },
    getRandom () {
      let str = ''
      const range = 11
      const arr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      for (let i = 0; i < range; i++) {
        const pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
      }
      return str
    },
    async getTeams () {
      const date = this.moment(this.range.start).startOf('day').toISOString()
      const duration = this.range.duration
      const params = { date, duration }
      if (this.status) {
        params.status = this.status
      }
      if (this.salesman) {
        params.salesmans = this.salesman
      }
      if (this.searchText) {
        params.search = this.searchText
      }
      const teams = await getapi('visitbooking/v2?' + new URLSearchParams(params))
      if (teams) {
        this.teams = [].concat(...teams.data.filter(e => e.status !== '已取消'), ...teams.data.filter(e => e.status === '已取消'))
        this.count = teams.count
      }
    },
    async getStatus () {
      this.statusmap = await getapi('selections/bookStatus')
    },
    async getSalesman () {
      const salesmans = await getapi('users/local/short')
      this.salesmans = salesmans
    }
  },
  data () {
    return {
      guideTopic: [],
      products: [],
      store: null,
      sourcesRest: [],
      sources: [],
      projects: [],
      selectProd: false,
      addTeam1: null,
      teamAttributes: [],
      printTable: false,
      printInfo: false,
      rangeSelect: false,
      range: {
        start: this.moment().format('yyyy-MM-DD'),
        duration: 0,
        end: null
      },
      listP: false,
      salesmans: [],
      statusmap: [],
      statusmap2: statusmap2,
      namemap: namemap,
      addTeam: false,
      itemSelect: null,
      salesman: null,
      searchText: null,
      status: null,
      fieldsCSV: [],
      fieldsNeed: [
        '狀態',
        '參觀日期',
        '時段',
        '預約人',
        '代理商',
        '領隊',
        '領隊電話',
        '預約人數',
        '導覽需求',
        '導覽員',
        '匯款資訊',
        '業務',
        'id',
        '團體ID',
        '參觀時段',
        '統一編號',
        '團體名稱',
        '票種',
        '總金額',
        '待收金額',
        '預約時間',
        '操作人員',
        '備註',
        '一般',
        '優待',
        '優惠'
      ],
      widths: [
        120,
        130,
        100,
        180,
        40,
        260,
        150,
        100,
        85,
        0,
        95,
        60
      ],
      aligns: [
        'center',
        'start',
        'start',
        'start',
        'center',
        'start',
        'start',
        'center',
        'center',
        'start',
        'center',
        'center'
      ],
      fieldsDetial: [
        '團體ID',
        '預約狀態',
        '參觀日期',
        '參觀時段',
        '預約人',
        '代理商',
        '統一編號',
        '領隊',
        '領隊電話',
        '團體名稱'
      ],
      fieldsDetial2: [
        '預約人數',
        '導覽需求',
        '票種',
        '總金額',
        '匯款預付'
      ],
      fields: [
        '狀態',
        '參觀日期',
        '時段',
        '預約人',
        '',
        '代理商',
        '領隊',
        // '領隊電話',
        '預約人數',
        // '導覽需求(人)',
        '導覽員',
        '匯款資訊/備註',
        '業務',
        '詳情'
      ],
      teams: [],
      items: []
    }
  }
}
</script>
<style lang="scss">
.TeamInformation {
  .vip, .vvip, .supervip {
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
    margin: auto;
  }
  .vip {
    background-image: url(/vip.svg);
  }
  .vvip {
    background-image: url(/vvip.svg);
  }
  .supervip {
    background-image: url(/supervip.svg);
  }
}
.customDate {
  .field-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
</style>
<style lang="scss" scoped>
.toolong {
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.remarkTip {
  position: relative;
  z-index: 10;
  &>svg {
    z-index: 11;
  }
  &>div {
    display: none;
  }
  &>svg:hover+div {
    display: block;
    position: absolute;
    width: 416px;
    background-color: var(--color-checked);
    color: #FFFFFF;
    font-weight: 400;
    font-size: 20px;
    line-height: 170%;
    left: -451px;
    padding: 20px;
    border-radius: 10px;
    top: 80px;
    text-align: start;
    z-index: 100;
  }
}
.status {
  position: relative;
}
.statusBtns {
  display: none;
  position: absolute;
  width: fit-content;
  background-color: transparent;
  left: 100px;
  top: -10px;
  bottom: -10px;
  height: 60px;
  border-radius: 3px;
  align-items: center;
  padding-inline: 10px;
  gap: 15px;
  button {
    height: 40px;
    width: 100px;
    border-radius: 20px;
    border: none;
    align-items: center;
    justify-content: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    // -1px -1px 4px 4px rgba(0, 0, 0, 0.25)
  }
}
.contract {
  width: 30px;
  height: 30px;
  background: #EE7E8D;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
}
tr {
  border-bottom: 1px solid var(--color-border);
  min-height: 100px;
  &.trempty:hover {
    background-color: transparent;
  }
}
th, td {
  text-align: start;
  padding-inline: 5px;
}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #E5E5E5;
}
th {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
}
.customDate {
  display: flex;
  position: fixed;
  top: 74px;
  left: 700px;
  width: 400px;
  height: 80px;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  background-color: #FFFFFF;
  border-radius: 5px;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
  button {
    height: 36px;
    width: 36px;
    border: none;
    padding: 0;
    background-color: #FFFFFF;
    &::before {
      content: '';
      display: inline-block;
      width: 36px;
      height: 36px;
      background-color: var(--color-checked);
      mask: center / 32px no-repeat url(/close.svg);
      font-size: 24px;
    }
  }
}
.status {
  display: inline-flex;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
}
.addTeam, .printTablefn {
  height: 50px;
  background: var(--color-checked);
  border-radius: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  border:none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  gap: 3px;
  &::before {
  content: '';
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  }
}
.addTeam::before {
  width: 29px;
  height: 29px;
  background-image: url(/plus.svg);
}
.addTeam::after {
  content: '新增預約';
}
.printTable {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 216px;
  height: 50px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  background-color: var(--color-checked);
  &::before {
    content: '';
    display: inline-block;
    width: 29px;
    height: 29px;
    background-color: #FFFFFF;
    mask:  center / contain no-repeat url(/print.svg);
  }
  &.excel::before {
    mask:  center / contain no-repeat url(/excel.svg);
  }
}
.printTablefn {
  width: 150px;
  padding-inline: 18px;
  &::before {
    width: 29px;
    height: 29px;
    background-color: #FFFFFF;
    mask: center / contain no-repeat url(/setting.svg);
    margin-right: 5px;
  }
}
.listP {
  position: absolute;
  right: 10px;
  top: 74px;
  display: flex;
  flex-direction: column;
  background-color: #FFF;
  gap: 1px;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  z-index: 50;
  &>.printTable {
    border: 3px;
    padding-inline: 10px;
    width: 176px;
    gap: 13px;
  }
}
@media screen and (min-width: 1850px) {
  .addTeam, .printTable {
    width: 150px;
  }
  .printTable::after {
    position: relative;
  }
  .addTeam::after {
    position: relative;
  }
  input[type=radio] {
    width: 125px;
    &::after {
      content: attr(after);
    }
  }
}
@media screen and (max-width: 1849px) {
  .addTeam, .printTable {
    width: 50px;
    position: relative;
  }
  .printTable::after, .addTeam::after {
    position: absolute;
    top: 50px;
    display: none;
  }
  .printTable:hover::after, .addTeam:hover:after {
    position: absolute;
    top: 60px;
    display: block;
    font-size: 20px;
    background-color: var(--color-pri);
  }
  input[type=radio] {
    width: 80px;

  }
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  // padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }

}
select {
  box-sizing: border-box;
  width: 155px;
  height: 40px;
  border: 1px solid #C4C4C4;
  border-radius: 3px;
  text-indent: 12px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
}
input[type=radio] {
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(before);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &::after {
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.TeamInformation {
padding-inline: 18px 9px!important;
table {
  min-height: 300px;
  height: 100%;
  tr.selected {
    background-color: var(--color-selected);
  }
  td {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
.header {
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  color: var(--color-pri);
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  gap: 20px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}

</style>
